<div class="prompt-library-list-container">
  <kendo-listview [data]="data() || []" class="prompt-library-list" containerClass="k-d-flex k-flex-col k-flex-nowrap">
    <ng-template kendoListViewItemTemplate let-libraryItem="dataItem">
      <div class="prompt-library-list-item-wrapper" [class.disabled]="isAutomationDisabled() || libraryItem.isDisabled">
        <div class="prompt-library-list-item-header">
          <button mat-button type="button" (click)="runPrompt(libraryItem)" [disabled]="isAutomationDisabled() || libraryItem.isDisabled" aria-label="Run Automation"
            disabledInteractive
            class="prompt-library-list-item-button"
            [matTooltip]="isAutomationDisabled() ? 'Automations are disabled while a Prompt, Instruction, or Workflow is running.' : (libraryItem.isDisabled ? 'This automation is disabled due to Sensitivity Label mismatch' : tooltipText + libraryItem.item.details.name)"
            matTooltipPosition="right">
            {{ libraryItem.item.details.name.length > 40 ? libraryItem.item.details.name.substring(0, 40) + '...' : libraryItem.item.details.name }}
          </button>
        </div>
        <div class="prompt-library-list-item-actions">
          <button mat-icon-button [matMenuTriggerFor]="promptActionsMenu" aria-label="Automation Actions"
            matTooltip="Automation Actions" matTooltipPosition="below">
            <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">more_horiz</mat-icon>
          </button>
          <mat-menu #promptActionsMenu="matMenu">
            @if (showEditAutomationButton(libraryItem)) {
              <button mat-menu-item type="button" (click)="editPrompt(libraryItem)" aria-label="Edit Automation">
                <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">edit</mat-icon>
                <span>Edit</span>
              </button>
            }
            <button mat-menu-item type="button" (click)="showPromptSummary(libraryItem)" aria-label="Automation Summary">
              <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">info</mat-icon>
              <span>Summary</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </ng-template>
    <ng-template kendoListViewEmptyTemplate>
      <div class="empty-state">
        <p class="prompt-name">No Automation available. Add a new Automation to get started.</p>
      </div>
    </ng-template>
  </kendo-listview>
</div>
